import { render, staticRenderFns } from "./CollectList.vue?vue&type=template&id=5c059c57&scoped=true"
import script from "./CollectList.vue?vue&type=script&lang=js"
export * from "./CollectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c059c57",
  null
  
)

export default component.exports